import { createContext, useContext } from "react";
import { SearchResultType } from "../../type";
import { SEARCH_FIELD_LIMIT, SEARCH_RESULTS_LIMIT } from "./constants";

export type { SearchResultType };
export { SEARCH_FIELD_LIMIT, SEARCH_RESULTS_LIMIT };

export type SearchType = {
  query: string | null;
  searchResults: SearchResultType["results"] | undefined;
  totalSearchItems: number | undefined;
  currentPage: number;
  handleSubmit: (searchInput: string) => Promise<void>;
};

export const SearchContext = createContext<SearchType | undefined>(undefined);

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) return {} as SearchType;

  return context;
};
